import lodash from "lodash";
import { HTMLData_Source } from "./../ricos-schema/legacy/wix/rich_content/v1";
import htmlDataDefaults from "./../ricos-schema/legacy/statics/html.defaults.json";
import { Node_Type } from "./../ricos-types";
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common";
import { INSERT_ADSENSE_BUTTON, INSERT_HTML_BUTTON } from "./data-hooks";
import { htmlButtonsTypes } from "./defaults";
import { AdsenseIcon, InsertPluginIcon } from "./icons";
import { HTML_TYPE } from "./types";
const toolbarsToAddIn = [
  TOOLBARS.MOBILE,
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE
];
const getAddButtons = (config, _services) => {
  const { exposeButtons = [htmlButtonsTypes.html], siteDomain } = config || {};
  const index = exposeButtons.indexOf(htmlButtonsTypes.adsense);
  if (!siteDomain && index > -1) {
    exposeButtons.splice(index, 1);
  }
  const buttonsMap = {
    [htmlButtonsTypes.html]: {
      id: `${Node_Type.HTML}.html`,
      label: INSERT_PLUGIN_BUTTONS.HTML,
      dataHook: INSERT_HTML_BUTTON,
      icon: InsertPluginIcon,
      tooltip: "HtmlPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ publicCommands }) => {
        publicCommands.insertBlockWithBlankLines(HTML_TYPE, htmlDataDefaults);
        return true;
      },
      menuConfig: {
        tags: "Video_plugin_search_tags"
      }
    },
    [htmlButtonsTypes.adsense]: {
      id: `${Node_Type.HTML}.adsense`,
      label: INSERT_PLUGIN_BUTTONS.ADSENSE,
      dataHook: INSERT_ADSENSE_BUTTON,
      icon: AdsenseIcon,
      tooltip: "AdSensePlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ publicCommands }) => {
        publicCommands.insertBlockWithBlankLines(HTML_TYPE, {
          ...htmlDataDefaults,
          source: HTMLData_Source.ADSENSE
        });
        return true;
      },
      menuConfig: {
        tags: "Video_plugin_search_tags",
        group: "embed"
      }
    }
  };
  return lodash.compact(exposeButtons.map((buttonType) => buttonsMap[buttonType]));
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
